import pick from 'lodash/pick';

import theme from '../../Theme';

import { VALID_BORDER_RADIUS_MEDIA_MAP } from './calcBorderRadiusStyles';
import { VALID_DIMENSION_DATA } from './calcDimensionStyles';
import { VALID_EDGE_STYLE_MEDIA_MAP } from './calcEdgeStyles';
import { VALID_MEDIA_STYLES, VALID_PICKED_MEDIA } from './common';

type VALID_MAKE_MEDIA_MAP =
  | VALID_MEDIA_STYLES
  | VALID_DIMENSION_DATA
  | VALID_EDGE_STYLE_MEDIA_MAP
  | VALID_BORDER_RADIUS_MEDIA_MAP;

export const makeMediaObj = (data: VALID_MAKE_MEDIA_MAP): VALID_PICKED_MEDIA =>
  pick(data, theme.global.breakPointSizes);
